import { Box, Link, Typography } from "@mui/material";

export const MIGHTY45_IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/mighty45/id1594939720";

export const MIGHTY45_ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.mighty45client";

/**
 * Lightweight download links shown in Coach Console surfaces (invite flow).
 *
 * @param {{
 *   compact?: boolean;
 *   sx?: object;
 *   helperTextVariant?: string;
 * }} props
 */
export default function Mighty45MobileStoreLinks({
  compact = false,
  sx,
  helperTextVariant = "body2",
} = {}) {
  return (
    <Box sx={sx}>
      {!compact ? (
        <Typography
          variant={helperTextVariant}
          color="text.secondary"
          sx={{ mb: 0.75 }}
        >
          Mighty45 installs on their phone/tablet via the stores (coach console is web-only).
        </Typography>
      ) : null}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Link
          href={MIGHTY45_IOS_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          App Store (iOS)
        </Link>
        <Link
          href={MIGHTY45_ANDROID_PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Play (Android)
        </Link>
      </Box>
    </Box>
  );
}
